<section class="section__notresult">
	<img src="assets/icons/search-zoom-out.svg" alt="icon" />
	<p class="section__notresult__message">{{ menssage }}</p>
	<p class="section__notresult__second__message" *ngIf="showSubtitle">Intenta redefinir tu búsqueda.</p>
	<p class="section__notresult__second__message" *ngIf="showTryAgain">Inténtalo de nuevo en otro momento</p>
</section>
